import { render, staticRenderFns } from "./ProCompusDialog.vue?vue&type=template&id=2fa1661c&scoped=true"
import script from "./ProCompusDialog.vue?vue&type=script&lang=js"
export * from "./ProCompusDialog.vue?vue&type=script&lang=js"
import style0 from "./ProCompusDialog.vue?vue&type=style&index=0&id=2fa1661c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1661c",
  null
  
)

export default component.exports